/* eslint-disable-next-line simple-import-sort/imports */
import "@babel/polyfill";
import { skipTreeshake } from "./src/init-platform-browser";
import "../stylesheets/fonts.css";
import "../stylesheets/learner-uppy-core.css";
import "../stylesheets/learner-uppy-dashboard.css";
import "../stylesheets/learner-uppy-image-editor.css";
import "../stylesheets/learner-uppy-webcam.css";
import "../stylesheets/video-js.min.css";
import "../stylesheets/videojs-style-overrides.css";

import React from "react";
import { createRoot } from "react-dom/client";

import App from "./src/App";

skipTreeshake();
const container = document.getElementById("app-main");
const root = createRoot(container!);
root.render(<App />);

(window as any).osClientJsLoadedAt = window.performance?.now?.() ?? Date.now();

const difference =
  (window as any).osClientJsLoadedAt - (window as any).osJsStartedAt;
const seconds = (difference / 1000).toFixed(2);
console.log(`OS Client JS finished execution after ${seconds} seconds.`);
